import { Container, Flex, Box } from 'theme-ui';

import { Personalize } from '@templates/product/Main/Details/Personalize';
import { Icons } from './Icons';
import { Header } from '../Header';
import { Options } from './Options';
import { SizeOptions } from './SizeOptions';
import { ColorOptions } from './ColorOptions';
import { AddToCart } from './AddToCart';
import { themed } from './Details.theme';
import { Upsells } from './Upsells';
import { BuyWithPrime } from '../BuyWithPrime';

export const Details = themed(
  ({
    theme,
    product,
    selectedVariant,
    currentProduct,
    titles,
    productUpsells,
    rebuyProducts,
  }) => {
    return (
      <Container data-comp={Details.displayName} sx={theme.wrapper}>
        <Box data-comp="StickyContainer" sx={theme.sticky}>
          <Flex sx={theme.sticky.wrapper}>
            <Box sx={{ display: ['none', null, 'block'] }}>
              <Header
                selectedVariant={selectedVariant}
                currentProduct={currentProduct}
                titles={titles}
              />
            </Box>

            <Box sx={{ display: ['none', null, 'block'] }}>
              <Icons product={currentProduct} />
            </Box>

            <Flex sx={theme.ctas}>
              {/* Sizes etc.. */}
              {product?.optionsMap && selectedVariant ? (
                <Options
                  options={product?.optionsMap}
                  handle={selectedVariant?.product?.handle}
                  image={selectedVariant?.image?.originalSrc}
                />
              ) : null}

              <SizeOptions product={currentProduct} />

              <ColorOptions product={product} />

              <AddToCart
                product={currentProduct}
                selectedVariant={selectedVariant}
                rebuyProducts={rebuyProducts}
              />

              {selectedVariant?.sku ? (
                <BuyWithPrime sku={selectedVariant.sku} />
              ) : null}

              {productUpsells?.length ? (
                <Box sx={{ width: '100%' }}>{productUpsells[0]}</Box>
              ) : (
                <Upsells selectedVariant={selectedVariant} />
              )}
            </Flex>
          </Flex>
        </Box>
      </Container>
    );
  }
);

Details.displayName = 'ProductDetails';
